module.exports = __webpack_public_path__ + "static/media/open-arrow.6f317a14.svg";